import React from 'react';
import { Link } from 'react-router-dom';

const SpeciesContent = ({ species }) => {
  return (
    <section className="px-12 py-24 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8">
      <div className="md:col-span-8 bg-surface-container-low p-12 rounded-xl relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="font-headline text-4xl mb-8 text-on-surface">The Migration Journey</h2>
          <div className="space-y-6 text-slate-300 leading-relaxed max-w-2xl font-body">
            <p>{species.description}</p>
            <p>{species.tips}</p>
          </div>
          <Link
            to={`/explorer?species=${species.id}`}
            className="mt-10 px-8 py-3 bg-gradient-to-r from-primary to-primary-container text-on-primary font-label font-semibold rounded-md inline-flex items-center gap-2 hover:brightness-110 transition-all"
          >
            View Migration Map
            <span className="material-symbols-outlined text-sm">north_east</span>
          </Link>
        </div>
        {/* Animated wireframe globe */}
        <div className="absolute -right-12 -bottom-12 w-80 h-80 opacity-[0.07] pointer-events-none">
          <svg viewBox="0 0 200 200" className="w-full h-full animate-spin" style={{ animationDuration: '40s' }}>
            <circle cx="100" cy="100" r="80" fill="none" stroke="#ffb887" strokeWidth="0.8" />
            <ellipse cx="100" cy="100" rx="80" ry="30" fill="none" stroke="#ffb887" strokeWidth="0.5" />
            <ellipse cx="100" cy="100" rx="80" ry="55" fill="none" stroke="#ffb887" strokeWidth="0.5" transform="rotate(20 100 100)" />
            <ellipse cx="100" cy="100" rx="30" ry="80" fill="none" stroke="#ffb887" strokeWidth="0.5" />
            <ellipse cx="100" cy="100" rx="55" ry="80" fill="none" stroke="#ffb887" strokeWidth="0.5" />
            <line x1="20" y1="100" x2="180" y2="100" stroke="#ffb887" strokeWidth="0.3" />
            <line x1="100" y1="20" x2="100" y2="180" stroke="#ffb887" strokeWidth="0.3" />
          </svg>
        </div>
      </div>

      <div className="md:col-span-4 space-y-8">
        <div className="bg-surface-container-highest p-8 rounded-xl">
          <h3 className="font-label text-xs uppercase tracking-widest text-primary mb-6">Conservation Status</h3>
          <div className="flex justify-between items-end mb-2">
            <span className="text-sm font-label text-slate-400">Status</span>
            <span className={`font-headline text-xl ${
              species.status === 'Least Concern' ? 'text-secondary' :
              species.status === 'Endangered' || species.status === 'Critically Endangered' ? 'text-error' :
              'text-primary'
            }`}>{species.status}</span>
          </div>
        </div>

        <div className="bg-surface-container-lowest p-8 rounded-xl">
          <h3 className="font-label text-xs uppercase tracking-widest text-primary mb-4">Migration Route</h3>
          <ul className="space-y-4">
            {species.route.map((point, i) => (
              <li key={i} className="flex gap-4 items-center">
                <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: species.color }} />
                <span className="text-sm text-slate-300 font-body">{point.name}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-surface-container-lowest p-8 rounded-xl">
          <h3 className="font-label text-xs uppercase tracking-widest text-primary mb-4">Migration Season</h3>
          <ul className="space-y-4">
            <li className="flex gap-4">
              <span className="material-symbols-outlined text-primary text-sm">flight_takeoff</span>
              <span className="text-sm text-slate-300 font-body">Departs: {species.seasons.depart}</span>
            </li>
            <li className="flex gap-4">
              <span className="material-symbols-outlined text-primary text-sm">flight_land</span>
              <span className="text-sm text-slate-300 font-body">Arrives: {species.seasons.arrive}</span>
            </li>
            <li className="flex gap-4">
              <span className="material-symbols-outlined text-primary text-sm">replay</span>
              <span className="text-sm text-slate-300 font-body">Returns: {species.seasons.return}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SpeciesContent;
